// External Dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Divider from 'material-ui/Divider';
import Paper from 'material-ui/Paper';
import { Link } from 'react-router';

// Internal Dependencies
import CoderCardBadgeList from './CoderCardBadgeList';
import CoderCardMetrics from './CoderCardMetrics';
import styles from '../styles/Styles';

// Component definition
class CoderCard extends Component {
  static propTypes = {
    badges: PropTypes.arrayOf(PropTypes.shape({})),
    coder: PropTypes.shape(),
    details: PropTypes.bool,
    index: PropTypes.number,
  }

  static contextTypes = {
    router: PropTypes.object,
  }

  handleLink = () => {
    this.context.router.push(this.linkTo);
  }

  render() {
    const thisStyle = styles.codersCard;
    const {
      badges,
      coder,
      details,
      index,
    } = this.props;

    if (!coder) return null;

    const badgeCount = coder.badges
      ? coder.badges.length
      : 0;

    const attendanceCount = coder.attendance
      ? Object.keys(coder.attendance).length
      : 0;

    const linkTo = details
      ? '/'
      : `/coder-details/${index}`;

    this.linkTo = linkTo;

    return (
      <Link to={this.linkTo}>
        <Paper style={thisStyle.Card} zDepth={5}>
          <div>
            <Paper style={thisStyle.mainSection}>
              <div style={thisStyle.CoderTitleText}>
                {coder.firstName} {coder.lastName.charAt(0)}.
              </div>
              <div style={thisStyle.CoderLevelText}>{coder.title}</div>
              <div style={thisStyle.badgesListDiv}>
                <CoderCardBadgeList
                  badges={badges}
                  coderBadges={coder.badges}
                  coderKey={index}
                  key={index}
                  coderName={coder.firstName}
                  size={thisStyle.badgeSize}
                />
              </div>
              <div style={thisStyle.metricsDiv}>
                <Divider />
                <CoderCardMetrics
                  attendanceCount={attendanceCount}
                  badgeCount={badgeCount}
                />
              </div>
            </Paper>
          </div>
        </Paper>
      </Link>
    );
  }
}

export default CoderCard;



/** WEBPACK FOOTER **
 ** ./src/ninjas/CoderCard.js
 **/